import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";

import Dashboard from "../../layouts/Dashboard";
import Automatic from "./Automatic";
import TriggerPanel from "./TriggerPanel";

export default () => {
  const { path } = useRouteMatch("/communications");

  return (
    <Dashboard scrollableContent>
      <Switch>
        <Route exact path={`${path}/automatic`}>
          <Automatic />
        </Route>
        <Route exact path={`${path}/automatic/:event/workflow/edit`}>
          <TriggerPanel />
        </Route>
      </Switch>
    </Dashboard>
  );
};
